import { render, staticRenderFns } from "./jump-to-develop.vue?vue&type=template&id=e54676e2&"
import script from "./jump-to-develop.vue?vue&type=script&lang=js&"
export * from "./jump-to-develop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports